import {
  Alert,
  Button,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Validation, { IDValidationResult } from '../Services/validation.service';
import AlertDialog from './Dialogs/AlertDialog';
import { DialogMetaDataWithMessage } from './DialogMetaDataWithMessage';
import { DisplayValue } from './Utils/DisplayValue';
import Utilities from './Utils/Utilities';
import AppService, {HeritageIdValidationResult} from '../Services/app.service';
import { IDType } from '../Services/IDValidationTypes';

let loadButtonRef: HTMLButtonElement | null = null;
enum Action {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  RECEIVE = 'RECEIVE',
  LOAD_RETURN = 'LR',
  TRUCK = 'TRUCKINFO',
  IDTYPE = 'IDTYPE'
}

function ProcessLineHaul() {
  const navigate = useNavigate();
  const validation = new Validation();
  const idRef = useRef<HTMLInputElement>();
  const qtyRef = useRef<HTMLInputElement>();
  const locationRef = useRef<HTMLInputElement>();
  const truckRef = useRef<HTMLInputElement>();

  const [tab, setTab] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => setTab(newValue);

  const [areButtonsDisabled, setAreButtonsDisabled] = useState<boolean>(true);
  const [idEntry, setIdEntry] = useState(new DisplayValue(''));
  const [truckEntry, setTruckEntry] = useState(new DisplayValue(''));
  const [locationEntry, setLocationEntry] = useState(new DisplayValue(''));
  const [quantityEntry, setQuantityEntry] = useState(new DisplayValue(''));
  const [idHeritageValidationResult, setIdHeritageValidationResult] = useState<HeritageIdValidationResult>();
  const [showSuccessToast, setShowSuccessToast] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string>('');
  const [lastFocusedField, setLastFocusedField] =
    useState<React.MutableRefObject<HTMLInputElement | undefined>>();
  const [truckLookupInProgress, setTruckLookupInProgress] = useState(false);

  const [alertDialogData, setAlertDialogData] = useState<DialogMetaDataWithMessage>({
    message: '',
    metaData: {
      showDialog: false,
      textFieldRefToBeFocused: undefined,
    },
  });

  const getProcessType = () =>
    tab === 0 ? 'DELIVERY' : 'RETURN';
  

  useEffect(Utilities.checkForScannedData(idEntry, locationRef), [idEntry]);
  useEffect(Utilities.onDialogWithMessageClosedFocusField(alertDialogData), [
    alertDialogData,
  ]);
  useEffect(Utilities.checkForScannedData(truckEntry, idRef), [truckEntry]);
  useEffect(Utilities.checkForScannedDataAndFocusButton(locationEntry, loadButtonRef), [
    locationEntry,
  ]);

  useEffect(Utilities.checkForScannedDataAndFocusButton(quantityEntry, loadButtonRef), [
    quantityEntry,
  ]);

  useEffect(() => {
    var pickupFieldsHaveAValue: boolean =
      Boolean(idEntry.getDisplayValue()) &&
      Boolean(truckEntry.getDisplayValue()) &&
      Boolean(quantityEntry.getDisplayValue());
    setAreButtonsDisabled(!pickupFieldsHaveAValue);
  }, [idEntry, truckEntry, quantityEntry]);

  function focusLostQty() {
    const qtyValue = quantityEntry.getDisplayValue();
    const quantityNumber: number = parseInt(qtyValue);
    const dialogMetaData = {
      showDialog: true,
      textFieldRefToBeFocused: qtyRef,
    };
    if (quantityEntry.getDisplayValue() !== '') {
      if (isNaN(quantityNumber)) {
        setAlertDialogData({
          message: 'Qty must be numeric',
          metaData: dialogMetaData,
        });
        setQuantityEntry(new DisplayValue(''));
      } else if (quantityNumber <= 0) {
        setAlertDialogData({
          message: 'Qty must be greater than zero.',
          metaData: dialogMetaData,
        });
        setQuantityEntry(new DisplayValue(''));
      }
    }
  }

  async function focusLostId() {
    const idValue = idEntry.getDisplayValue();
    if (idValue.length > 0 && !truckLookupInProgress) {
      const appService = new AppService();
      setTruckLookupInProgress(true);
      const action = Action.IDTYPE;
      const validationResponse = await appService.processLineHaul(
                idValue,
                '',
                '',
                action,
                '',
                '',
                '',
            );
      const isInvalid = !validationResponse.valid;
      const backendIdType = validationResponse.idType;

      setIdHeritageValidationResult({
        id: idValue,
        type: backendIdType,
        isValid: validationResponse.valid,
        message: validationResponse.error || ""
      });

      const isReturn = getProcessType() === 'RETURN';
        const isAllowedType =
            backendIdType === "EPC" ||
            backendIdType === "POID" ||
            backendIdType === "SKU"
      if (isInvalid || (isReturn && !isAllowedType)) {
        let errMsg = isInvalid ? validationResponse.error : ''
        if (isReturn && !isAllowedType) {
          errMsg = 'Only EPC, POID or SKU can be processed for returns.';
        }
        setAlertDialogData({
          message: errMsg,
          metaData: {
            showDialog: true,
            textFieldRefToBeFocused: idRef,
          },
        });
        setIdEntry(new DisplayValue(''));
      }else {
        if (backendIdType === "EPC" || backendIdType === "POID") {
          setQuantityEntry(new DisplayValue('1'));
        }
        if(backendIdType !== "SKU"){
            const processType = getProcessType();
            const action = Action.TRUCK;
            const quantityToSend = quantityEntry.getDisplayValue() || '1';
            const response = await appService.processLineHaul(
                idValue,
                backendIdType || '',
                locationEntry.getDisplayValue(),
                action,
                processType,
                quantityToSend,
                truckEntry.getDisplayValue(),
            );
            if (response.truck) {
                setTruckEntry(new DisplayValue(response.truck));
            }
            if (response.error) {
              const dialogMetaData = {
                showDialog: true,
                textFieldRefToBeFocused: idRef,
              };
              setAlertDialogData({
                message: response.error,
                metaData: dialogMetaData,
              });
            }
          }
      }
      setTruckLookupInProgress(false);
    }
  }
  
  async function actionButtonClicked(action: Action) {
    const appService = new AppService();
    const dialogMetaData = {
      showDialog: true,
      textFieldRefToBeFocused: locationRef,
    };
    const currentType = idHeritageValidationResult?.type ?? IDType.INVALID;
    const processType = getProcessType();
    if (processType === 'RETURN' && !(currentType === "EPC" || currentType === "POID" || currentType === "SKU")) {
      setAlertDialogData({
        message: 'Only EPC, POID or SKU can be processed for returns.',
        metaData: {
          showDialog: true,
          textFieldRefToBeFocused: idRef,
        },
      });
      setIdEntry(new DisplayValue(''));
      return;
    }
    if ( action === Action.RECEIVE && locationEntry.getDisplayValue() === '')
     {
      setAlertDialogData({
        message: 'Please enter a location code',
        metaData: dialogMetaData,
      });
      return;
    }
    const quantity =
            currentType === "PICKID" || currentType === "SKU"? quantityEntry.getDisplayValue() : '1';
          setQuantityEntry(new DisplayValue(quantity));
    let result = await appService.processLineHaul(
      idHeritageValidationResult?.id ?? '',
      idHeritageValidationResult?.type || '',
      locationEntry.getDisplayValue(),
      action,
      processType,
      quantity,
      truckEntry.getDisplayValue(),
    );
    if (!result.valid) {
      setAlertDialogData({
        message: result.error,
        metaData: {
          showDialog: true,
          textFieldRefToBeFocused: lastFocusedField,
        },
      });
      return;
    }
      if(result.truck){
        setTruckEntry(new DisplayValue(result.truck));
      }
      let toastMsg = '';
        switch (action) {
          case Action.LOAD:
            toastMsg = 'Item Loaded';
            break;
          case Action.UNLOAD:
            toastMsg = 'Item Unloaded';
            break;
          case Action.RECEIVE:
            toastMsg = 'Item Received';
            break;
          case Action.LOAD_RETURN:
            toastMsg = 'Item Returned at CampusHub';
            break;
          default:
            toastMsg = 'Action completed';
        }
      setShowSuccessToast(true);
      setIdEntry(new DisplayValue(''));
      setLocationEntry(new DisplayValue(''));
      setTruckEntry(new DisplayValue(''));
      setQuantityEntry(new DisplayValue('1'));
      idRef?.current?.focus();
  }
  function clearButtonClicked() {
    setTruckEntry(new DisplayValue(''));
    setIdEntry(new DisplayValue(''));
    setLocationEntry(new DisplayValue('')); 
    setQuantityEntry(new DisplayValue(''));  
    truckRef?.current?.focus();
  }

  const renderButtons = () => {
    const location = tab === 0 ? 'ZDock' : 'CampusHub';
    return (
      <Grid container spacing={2} px={2}>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            sx={{ height: '36px' }}
            ref={(node) => {
              loadButtonRef = node;
            }}
            disabled={areButtonsDisabled}
            onClick={() => {
              actionButtonClicked(Action.LOAD);
            }}
          >
            Load
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            sx={{ height: '36px' }}
            disabled={areButtonsDisabled}
            onClick={() => {
              actionButtonClicked(Action.UNLOAD);
            }}
          >
            Unload
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            sx={{ height: '36px' }}
            disabled={areButtonsDisabled}
            onClick={() => {
              actionButtonClicked(Action.RECEIVE);
            }}
          >
            Receive at {location}
          </Button>
        </Grid>
      </Grid>
    );
  };
  

  function hasTouch() {
    return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
  }

  if (hasTouch()) {
    try {
      for (var sheetIndex in document.styleSheets) {
        var styleSheet = document.styleSheets[sheetIndex];
        if (!styleSheet.cssRules) continue;

        for (
          var ruleIndex = styleSheet.cssRules.length - 1;
          ruleIndex >= 0;
          ruleIndex--
        ) {
          if (!styleSheet.cssRules[ruleIndex].cssText) continue;

          if (styleSheet.cssRules[ruleIndex].cssText.match(':hover')) {
            styleSheet.deleteRule(ruleIndex);
          }
        }
      }
    } catch (exception) {}
  }
 
  return (
    <div>
      <Snackbar
        open={showSuccessToast}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={() => {
          setShowSuccessToast(false);
        }}
      >
        <Alert severity="success" sx={{ width: '100%' }} variant="filled">
          {toastMessage}
        </Alert>
      </Snackbar>
      <AlertDialog
        message={alertDialogData?.message}
        showDialog={alertDialogData?.metaData.showDialog}
        closeDialog={() => {
          setAlertDialogData({
            message: '',
            metaData: {
              showDialog: false,
              textFieldRefToBeFocused: alertDialogData.metaData.textFieldRefToBeFocused,
            },
          });
        }}
      />

      <Stack height={'442px'} flexShrink={0} paddingRight={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="baseline">
          <Typography paddingTop={3} paddingLeft={2} marginBottom={3} variant="h6">
            Process ZDock Manifest 
          </Typography>
          <Button
            sx={{ width: '100px' }}
            variant="contained"
            size="small"
            onClick={() => {
              navigate('/Main');
            }}
          >
            DONE
          </Button>
        </Stack>
        <Stack direction="row" spacing={2} px={2} mb={2}>
          <Button
            variant={tab === 0 ? 'contained' : 'outlined'}
            size="medium"
            onClick={() => setTab(0)}
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              flex: 1,
            }}
          >
            Linehaul to ZDock
          </Button>
          <Button
            variant={tab === 1 ? 'contained' : 'outlined'}
            size="medium"
            onClick={() => setTab(1)}
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              flex: 1,
            }}
          >
            Linehaul Return from ZDock
          </Button>
        </Stack>

        <Typography variant="subtitle1" lineHeight={1}>
          <Grid
            container
            direction={'row'}
            rowSpacing={2}
            alignItems={'flex-start'}
            justifyContent={'flex-end'}
            columnSpacing={1}
            paddingLeft={2}
          >

            <Grid item xs={3} justifyContent={'left'} alignSelf={'center'}>
              ID
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                multiline
                minRows={1}
                maxRows={1}
                inputProps={{ 'aria-label': 'idInput' }}
                inputRef={idRef}
                value={idEntry.getDisplayValue()}
                onChange={(eventData) => {
                  setIdEntry(new DisplayValue(eventData.target.value));
                }}
                onBlur={() => {
                  focusLostId();
                }}
                onFocus={() => {
                  setLastFocusedField(idRef);
                }}
              ></TextField>
            </Grid>            
            <Grid item xs={3} justifyContent={'left'} alignSelf={'center'}>
            Quantity
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                inputProps={{ 'aria-label': 'quantityInput' }}
                inputRef={qtyRef}
                multiline
                minRows={1}
                maxRows={1}
                value={quantityEntry.getDisplayValue()}
                onChange={(e) => setQuantityEntry(new DisplayValue(e.target.value))}
                onBlur={focusLostQty}
                onFocus={() => setLastFocusedField(qtyRef)}
              />
            </Grid>
            <Grid item xs={3} justifyContent={'left'} alignSelf={'center'}>
              LH
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                inputProps={{ 'aria-label': 'truckInput' }}
                multiline
                minRows={1}
                maxRows={1}
                inputRef={truckRef}
                value={truckEntry.getDisplayValue()}
                onChange={(eventData) => {
                  setTruckEntry(new DisplayValue(eventData.target.value));
                }}
                onFocus={() => {
                  setLastFocusedField(truckRef);
                }}
              ></TextField>
            </Grid>
            <Grid item xs={3} justifyContent={'left'} alignSelf={'center'}>
              Location
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                inputProps={{ 'aria-label': 'locationInput' }}
                inputRef={locationRef}
                multiline
                minRows={1}
                maxRows={1}
                value={locationEntry.getDisplayValue()}
                onChange={(eventData) => {
                  setLocationEntry(new DisplayValue(eventData.target.value));
                }}
                onFocus={() => {
                  setLastFocusedField(locationRef);
                }}
              ></TextField>
            </Grid>
            <Grid xs={12} sx={{ mt: 3 }}>
              {renderButtons()}
            </Grid>
            <Grid item xs={12} justifyContent={'left'} alignSelf={'center'}>
              <Stack direction="column" spacing={1}>
                <Button
                  id="clear-button"
                  fullWidth
                  variant="contained"
                  size="small"
                  onClick={() => {
                    clearButtonClicked();
                  }}
                >
                  CLEAR
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Typography>
      </Stack>
    </div>
  );
}

export default ProcessLineHaul;
